export const SAVED_CARTE_ID = "savedCarteId"
export const SAVED_CARTE_STATUS = "savedCarte_Status"

